module.exports = __webpack_public_path__ + "static/media/photo242.426fd30e.jpg";